import React, { useState, useCallback } from "react";
import { 
  SuccessMessage,
  FailMessage,
  Loading,
  FormatValueToDecimal,
  CompanySelect,
  FormatDateToMDY,
  DateSelect,
  CustomerSelect,
  FormatDateToWord
} from "../../common/APICommon";
import { apiUrl } from "../../utils/Configuration";
import axios from 'axios';
import { PDFDocument, rgb } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import NoAccess from "../NoAccess";
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

export default function StatementOfAccount() {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
//#endregion






//#region Variables 
  const [customer, setCustomer] = useState(null);
  const [company, setCompany] = useState(null);
  const today = new Date().toISOString().split("T")[0];
  const [dateFrom, setDateFrom] = useState(today);
  const [dateTo, setDateTo] = useState(today);
  const [showCustomerSelect, setShowCustomerSelect] = useState(false);
  
  const openCustomerSelect = () => {
    setShowCustomerSelect(true)
  }
  const closeCustomerSelect = () => {
    setShowCustomerSelect(false)
  }
//#endregion






//#region Generate
  const fetchReportData = useCallback(async (_data) => {
    const body = {
      customerId: _data.customerId,
      dateFrom: dateFrom,
      dateTo: dateTo,
    }

    try {
      // const response = await axios.post(`${apiUrl}/api/Report/report-data/statement-of-account`, body, {
      const response = await axios.post(`${apiUrl}/api/Report/report-data/statement-of-account`, body, {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, [dateFrom, dateTo]);

  const generateHandleClick = async () => {
    if(!dateFrom || !dateTo || !company || !customer){
      setFailMessage("Please fill up required fields")
      return;
    }

    setLoading(true)

    const _data = await fetchReportData(customer);

    try {
      // Load the existing PDF template
      const pdfUrl = `${window.location.origin}/docs/STATEMENT_OF_ACCOUNT.pdf`;
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);
      // let page = pdfDoc.getPages()[0];

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      // Helper function to wrap text
      const wrapText = (text, maxWidth, font, fontSize) => {
        if (!text) return [""];
        const words = text.split(/(?<=-)|\s+/);
        const lines = [];
        let currentLine = '';
        for (const word of words) {
          const testLine = currentLine ? `${currentLine}${word}` : word;
          if (font.widthOfTextAtSize(testLine, fontSize) <= maxWidth) {
            currentLine = testLine;
          } else {
            if (currentLine) lines.push(currentLine);
            currentLine = word;
          }
        }
        if (currentLine) lines.push(currentLine);
        return lines;
      };

      const drawHeader = (targetPage) => {
        // Header Info
        targetPage.drawText(company.name?.toString() ?? "", {
          x: 35, y: 741, size: 16, font: calibriBold, color: rgb(0, 0, 0),
        });

        targetPage.drawText(company.address?.toString() ?? "", {
          x: 35, y: 731, size: 9, font: calibriFont, color: rgb(0, 0, 0),
        });

        targetPage.drawText(company.tin?.toString() ?? "", {
          x: 35, y: 721, size: 9, font: calibriFont, color: rgb(0, 0, 0),
        });

        targetPage.drawText(customer.name1 ?? "", {
          x: 35, y: 580, size: 11, font: calibriBold, color: rgb(0, 0, 0),
        });

        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, {
          x: 275,
          y: 635,
          size: 9,
          font: calibriBold,
          color: rgb(0, 0, 0),
        });
      };

      let currentPage = pdfDoc.getPages()[0];
      drawHeader(currentPage);

      /* // Header Info
      page.drawText(company.name?.toString() ?? "", {
        x: 35, y: 741, size: 16, font: calibriBold, color: rgb(0, 0, 0),
      });

      page.drawText(company.address?.toString() ?? "", {
        x: 35, y: 731, size: 9, font: calibriFont, color: rgb(0, 0, 0),
      });

      page.drawText(company.tin?.toString() ?? "", {
        x: 35, y: 721, size: 9, font: calibriFont, color: rgb(0, 0, 0),
      });

      page.drawText(customer.name1 ?? "", {
        x: 35, y: 580, size: 11, font: calibriBold, color: rgb(0, 0, 0),
      });

      page.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, {
        x: 275,
        y: 635,
        size: 9,
        font: calibriBold,
        color: rgb(0, 0, 0),
      }); */

      // TABLE LOGIC
      let yPosition = 530;
      const bottomThreshold = 60; // When to trigger a new page
      const colWidthAccount = 100;
      const colWidthHeader = 100; 
      const lineHeight = 10;

      let totalAmount = 0;
      let totalPayment = 0;
      let totalBalance = 0;

      for (let index = 0; index < _data?.length; index++) {
        if (yPosition < bottomThreshold) {
          currentPage = pdfDoc.addPage([currentPage.getWidth(), currentPage.getHeight()]);
          drawHeader(currentPage);
          yPosition = 530; 
        }

        const itemData = _data[index];

        const docNoString = `${itemData.referenceNumber?.toString() ?? ""}`;
        const docPaymentNoString = `${itemData.paymentNumber?.toString() ?? ""}`;

        // Wrap the text for both columns
        const docPaymentNoLines = wrapText(docPaymentNoString, colWidthAccount, calibriFont, 9);
        const docNoLines = wrapText(docNoString, colWidthHeader, calibriFont, 9);

        // Find how many lines this row will take
        const maxLines = Math.max(docPaymentNoLines.length, docNoLines.length);

        // FIX: Use standard for-loop instead of .forEach to avoid "no-loop-func" error
        for (let j = 0; j < docNoLines.length; j++) {
          currentPage.drawText(docNoLines[j], {
            x: 45,
            y: yPosition - (j * lineHeight),
            size: 9,
            font: calibriFont,
            color: rgb(0, 0, 0),
          });
        }

        // FIX: Use standard for-loop instead of .forEach to avoid "no-loop-func" error
        for (let i = 0; i < docPaymentNoLines.length; i++) {
          currentPage.drawText(docPaymentNoLines[i], {
            x: 263,
            y: yPosition - (i * lineHeight),
            size: 9,
            font: calibriFont,
            color: rgb(0, 0, 0),
          });
        }

        
        currentPage.drawText(`${FormatDateToMDY(itemData.date)}`, { x: 138, y: yPosition, size: 9, font: calibriFont });
        currentPage.drawText(FormatValueToDecimal(itemData.amount)?.toString() ?? "", { x: 193, y: yPosition, size: 9, font: calibriFont, color: rgb(0, 0, 0) });
        currentPage.drawText(`${FormatDateToMDY(itemData.paymentDate)}`, { x: 363, y: yPosition, size: 9, font: calibriFont });
        currentPage.drawText(FormatValueToDecimal(itemData.payment)?.toString() ?? "", { x: 424, y: yPosition, size: 9, font: calibriFont, color: rgb(0, 0, 0) });
        currentPage.drawText(FormatValueToDecimal(itemData.balance)?.toString() ?? "", { x: 500, y: yPosition, size: 9, font: calibriFont, color: rgb(0, 0, 0) });

        totalAmount += itemData.amount
        totalPayment += itemData.payment
        totalBalance += itemData.balance

        // Adjust yPosition for the next entry
        const dynamicIncrement = Math.max(20, (maxLines * lineHeight) + 5);
        yPosition -= dynamicIncrement;
      }

      if (yPosition < 160) { 
        currentPage = pdfDoc.addPage([currentPage.getWidth(), currentPage.getHeight()]);
        yPosition = 530; // Reset to top of new page
        drawHeader(currentPage); // Draw header on the new page too
      }

      currentPage.drawLine({
        start: { x: 40, y: yPosition },
        end: { x: 580, y: yPosition },
        thickness: 1,
        color: rgb(0, 0, 0),
      });
      currentPage.drawText("TOTAL", { x: 45, y: yPosition - 10, size: 7, font: calibriBold });
      currentPage.drawText(FormatValueToDecimal(totalAmount)?.toString() ?? "", { x: 193, y: yPosition - 10, size: 9, font: calibriBold });
      currentPage.drawText(FormatValueToDecimal(totalPayment)?.toString() ?? "", { x: 424, y: yPosition - 10, size: 9, font: calibriBold });
      currentPage.drawText(FormatValueToDecimal(totalBalance)?.toString() ?? "", { x: 500, y: yPosition - 10, size: 9, font: calibriBold });


      currentPage.drawLine({
        start: { x: 40, y: yPosition - 50 },
        end: { x: 140, y: yPosition - 50 },
        thickness: 1,
        color: rgb(0, 0, 0),
      });
      currentPage.drawText("Prepared by", { x: 70, y: yPosition - 60, size: 7, font: calibriBold });

      currentPage.drawLine({
        start: { x: 250, y: yPosition - 50 },
        end: { x: 350, y: yPosition - 50 },
        thickness: 1,
        color: rgb(0, 0, 0),
      });
      currentPage.drawText("Approved by", { x: 280, y: yPosition - 60, size: 7, font: calibriBold });

      currentPage.drawLine({
        start: { x: 450, y: yPosition - 50 },
        end: { x: 550, y: yPosition - 50 },
        thickness: 1,
        color: rgb(0, 0, 0),
      });
      currentPage.drawText("Received by", { x: 480, y: yPosition - 60, size: 7, font: calibriBold });

      // Save and Download PDF
      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `STATEMENT_OF_ACCOUNT.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(a.href);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }

    setLoading(false)
  }
//#endregion






//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasStatementOfAccount) {
    return <NoAccess />;
  }
//#endregion






//#region UI
  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
              <HistoryEduIcon fontSize="large" className="text-theme-color" />
              {`Statement of Account`}
            </h2>
            <p className="text-gray-500 mt-1">Summary of all transactions.</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="max-w-2xl">
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Customer <span className="text-red-500">*</span>
            </label>
            <div className="flex flex-row items-center">
              <input
                type="text"
                placeholder="Select Customer"
                className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                value={`${customer ? `${customer?.customerId} - ${customer?.name1}` : ""}`}
                readOnly
              />
              {!customer ?
                <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openCustomerSelect}>
                  <PersonSearchIcon className="text-white"/>
                </button> 
                :
                <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setCustomer(null)}>
                  <RemoveCircleIcon className="text-white"/>
                </button>
              }
            </div>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Company <span className="text-red-500">*</span>
            </label>
            <CompanySelect data={company} setData={setCompany} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Date From <span className="text-red-500">*</span>
            </label>
            <DateSelect data={dateFrom} setData={setDateFrom} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Date To <span className="text-red-500">*</span>
            </label>
            <DateSelect data={dateTo} setData={setDateTo} isEditable={true}/>
          </div>
        </div>

        <button onClick={generateHandleClick} className="mt-10 flex items-center gap-2 bg-theme-color text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md">
          <RestartAltIcon fontSize="small" /> Generate
        </button>
      </div>

      <CustomerSelect 
        visible={showCustomerSelect} 
        onClose={closeCustomerSelect}
        modalName={"Select Customer"}
        data={customer} setData={setCustomer}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
//#endregion
}